import { icons } from 'src/assets/iconDef/icon.def';

export const serviceWorkflowMenuDef = [
    {
        "name": "menu.bill_summary",
        "resource": "bill_summary",
        "icon": "fa fa-user-md",
        "url": "bill_summary",
        "auto_crud": true
    },
    {
        "name": "menu.bill_details",
        "resource": "bill_details",
        "icon": "fa fa-user-md",
        "url": "bill_details",
        "auto_crud": true
    },
    {
        "name": "menu.gate_in",
        "resource": "gate_in",
        "icon": "fa fa-user-md",
        "url": "gate_in",
        "auto_crud": true
    },
    {
        "name": "menu.gate_pass_item_details",
        "resource": "gate_pass_item_details",
        "icon": "fa fa-user-md",
        "url": "gate_pass_item_details",
        "auto_crud": true
    },
    {
        "name": "menu.webhook_route",
        "resource": "webhook_route",
        "icon": icons.list.horizontalList,
        "url": "webhook_route",
        "auto_crud": true
    },
    {
        "name": "menu.chatbot_signing_key",
        "resource": "chatbot_signing_key",
        "icon": icons.list.horizontalList,
        "url": "chatbot_signing_key",
        "auto_crud": true
    }
]